<!--
Copyright (c) 2020 GanttProject Cloud OU.
Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
-->
<template>
    <div id="modal-new-invite" class="modal fade" tabindex="-1" role="dialog"
         aria-labelledby="modal-new-invite-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" @keydown="applyShortcut">
                <div class="modal-header">
                    <h5 class="modal-title" id="modal-new-invite-title">Invite New Member</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="hide">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-group">
                            <label for="modal-new-invite-name">Name</label>
                            <input type="text" class="form-control" id="modal-new-invite-name" placeholder="How shall we call them?"
                                   v-model="inviteName">
                            <small class="form-text text-muted">We will use this name to build an email text.</small>
                        </div>
                        <div class="form-group">
                            <label for="modal-new-invite-email">Email</label>
                            <input type="text" class="form-control" id="modal-new-invite-email" placeholder="Valid email"
                                   v-model="inviteEmail" @input="errorMessage = ''">
                            <small class="form-text text-muted">Read our
                                <a href="/about/tos" target="_blank">ToS</a> and
                                <a href="/about/privacy" target="_blank">Privacy policy</a>.
                                TL;DR: neither we nor you abuse the email service.</small>
                        </div>
                        <div class="alert alert-danger" role="alert" v-if="errorMessage">
                            {{ errorMessage }}
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <BtnSubmit title="Send Invitation" spinner ref="submitButton" :submitHandler="invite">
                    </BtnSubmit>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';
import {ShortcutHandler, xhrErrorMessage} from '../utils/Ui';
import {TeamInvite} from '../Routes';
import {TeamDto} from '../Teams';
import BtnSubmit from './BtnSubmit.vue';

import $ from 'jquery';

@Component({
  components: {BtnSubmit},
})
export default class TeamInviteModal extends Vue {
  @Prop()
  public dashboardRefresh: () => void;

  @Prop()
  public team: TeamDto;
  private shortcutHandler = new ShortcutHandler();

  public inviteName = '';
  public inviteEmail = '';
  public errorMessage = '';

  public mounted() {
    this.shortcutHandler.register('Enter', this.invite);
  }

  public invite(): JQueryPromise<any> {
    if (!this.team) {
      this.hide();
      return;
    }

    this.errorMessage = '';
    return TeamInvite.invoke({
      refid: this.team.refid,
      name: this.inviteName,
      email: this.inviteEmail,
    }).done(() => {
      this.hide();
      this.dashboardRefresh();
    }).fail((jqXhr) => {
      const message = xhrErrorMessage(jqXhr, 'Failed to create invitation');
      this.errorMessage = jqXhr.status ? `${message} (HTTP ${jqXhr.status})` : message;
      this.dashboardRefresh();
    });
  }

  private applyShortcut(e: KeyboardEvent) {
    this.shortcutHandler.handle(e);
  }

  private hide() {
    this.inviteName = '';
    this.inviteEmail = '';
    this.errorMessage = '';
    $('#modal-new-invite').modal('hide');
  }
}
</script>
